import { Navigate } from 'react-router-dom';
import { useAuth } from 'context/authContext';
import { ROLE_TYPES } from 'api/constants';

const ProtectedClientRoute = ({ children }) => {
  const { auth, role } = useAuth();

  if (auth && role === ROLE_TYPES.client) return children;

  return <Navigate to="/login" replace />;
};

export default ProtectedClientRoute;
